import React from "react";

import logo from "../images/teleflex-logo.svg"

function Footer() {
  return (
    <div>
      <div className="footer-v3">
        <div className="footer">
          <div className="container m-padding">
            <div className="row">

              <div className="col-md-3 md-margin-bottom-40">
                <div className="thumb-headline">
                  <h2><a href="https://www.teleflex.com/usa/en/product-areas/index.html">OUR PRODUCTS</a></h2>
                </div>
                <ul className="list-unstyled simple-list margin-bottom-20">
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/product-areas/anesthesia/index.html">Anesthesia</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/product-areas/interventional/index.html">Interventional Cardiology/Radiology</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/product-areas/emergency-medicine/index.html">Emergency Medicine</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.urolift.com/">Interventional Urology - UroLift System</a>
                  </li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/product-areas/military-federal/">Military - Federal</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/product-areas/surgical/index.html">Surgical</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/product-areas/urology/">Urology</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/product-areas/vascular-access/index.html">Vascular Access</a></li>
                </ul>
              </div>

              <div className="col-md-3 md-margin-bottom-40">
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="http://www.teleflexmedicaloem.com/">TELEFLEX MEDICAL OEM</a></h2>
                </div>
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/suppliers/global-sourcing/index.html">SUPPLIERS</a></h2>
                </div>
              </div>

              <div className="col-md-3 md-margin-bottom-40">
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/about-us/index.html">ABOUT US</a></h2>
                </div>
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/careers/index.html">CAREERS</a></h2>
                </div>
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://investors.teleflex.com">INVESTORS</a></h2>
                </div>
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/legal/ca-proposition-65/index.html">LEGAL</a></h2>
                </div>
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/compliance/compliance/index.html">COMPLIANCE</a></h2>
                </div>
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/legal/internet-privacy-policy/index.html">PRIVACY</a></h2>
                </div>
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/legal/trademarks/index.html">TRADEMARKS</a></h2>
                </div>
              </div>

              <div className="col-md-3 md-margin-bottom-40">
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/global/en/index.html">GLOBAL REACH</a></h2>
                </div>
                <ul className="list-unstyled simple-list margin-bottom-20">
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/index.html">United States</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/la/en/index.html">Latin America</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/sea/en/contact/asia-pacific/">Asia Pacific</a></li>
                  <li><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/emea/en/index.html">Europe, Middle East, Africa</a></li>
                </ul>
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/services/customer-services/">SERVICES</a></h2>
                </div>
                <div className="thumb-headline">
                  <h2><a target="_blank" rel="noopener noreferrer" href="https://www.teleflex.com/usa/en/contact/north-america/index.html">CONTACT</a></h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 footnote">
              </div>
            </div>
          </div>
        </div>

        <div className="copyright">
          <div className="container">
              <div className="row">
                <div className="col-md-9">
                  <p>&copy; 2024 Teleflex Incorporated. All Rights Reserved.</p>
                </div>
                <div className="col-md-3">
                  <a href="https://www.teleflex.com/usa/en/index.html" target="_blank" rel="noopener noreferrer">
                    <img src={logo} alt="Logo" className="logo" />
                  </a>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
